import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: refactor this to use crystal-ui
import { MenuPopover, MenuItem, Hidden, Box } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import { MoreVertOutlineIcon } from '@applyboard/ui-icons';
import { Button, useId } from '@applyboard/crystal-ui';
import { ApplicationActionName } from "../../../../types";
import { ChangeIntakeModal } from "../ChangeIntakeModal";
import { ProgramType, useApplicationAvailableActions, useCancelApplication, useLegacyApplication } from "../../data";
import { RecommendedProgramsDialog } from "../RecommendedProgramsDialog";
import { RequestDeferralDialog } from "../RequestDeferralDialog";
import { RequestTuitionDepositRefundDialog } from "../RequestTuitionDepositRefundDialog";
import { CancelApplicationModal } from '@applyboard/ab-application-legacy';
import { ProcessDeferralModal } from "../ProcessDeferralModal";
import { ChangeProgramModal } from "../ChangeProgramModal";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ActionsMenu = function ActionsMenu(props) {
  var _applicationAvailable;
  var _useCancelApplication = useCancelApplication(),
    cancelApplication = _useCancelApplication.cancelApplication,
    isCancellingApplication = _useCancelApplication.isCancellingApplication;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var ref = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAction = _useState4[0],
    setSelectedAction = _useState4[1];
  var _useApplicationAvaila = useApplicationAvailableActions(),
    applicationAvailableActions = _useApplicationAvaila.applicationAvailableActions;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var program = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var programEsl = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var menuId = useId();
  var actions = (_applicationAvailable = applicationAvailableActions.map(function (action) {
    switch (action.id) {
      case ApplicationActionName.CHANGE_INTAKE:
        return {
          id: action.id,
          name: 'Change intake',
          showOutsideDropdown: true
        };
      case ApplicationActionName.FINISH_DEFERRAL:
        return {
          id: action.id,
          name: 'Finish deferral'
        };
      case ApplicationActionName.CANCEL_DEFERRAL:
        return {
          id: action.id,
          name: 'Cancel deferral'
        };
      case ApplicationActionName.CANCEL:
        return {
          id: action.id,
          name: 'Cancel application'
        };
      case ApplicationActionName.RECOMMENDED_PROGRAM:
        return {
          id: action.id,
          name: 'See recommended programs'
        };
      case ApplicationActionName.REQUEST_DEFERRAL:
        return {
          id: action.id,
          name: 'Request deferral'
        };
      case ApplicationActionName.REQUEST_TUITION_DEPOSIT_REFUND:
        return {
          id: action.id,
          name: 'Request tuition refund'
        };
      case ApplicationActionName.CHANGE_PROGRAM:
        return {
          id: action.id,
          name: 'Change program'
        };
    }
    return null;
  }).filter(Boolean)) !== null && _applicationAvailable !== void 0 ? _applicationAvailable : [];
  if (!(actions !== null && actions !== void 0 && actions.length)) {
    return null;
  }
  var _onClick = function onClick(id) {
    setSelectedAction(id);
    switch (id) {
      case ApplicationActionName.CANCEL:
        trackEvent({
          event: 'Single Application - Action Menu - Clicked Cancel Application Action'
        });
        break;
      case ApplicationActionName.CHANGE_INTAKE:
        trackEvent({
          event: 'Single Application - Action Menu - Clicked on Intake Change',
          data: {
            programId: program === null || program === void 0 ? void 0 : program.programId,
            programLevelText: program === null || program === void 0 ? void 0 : program.levelText,
            schoolId: legacyApplication.school.id,
            schoolCountry: legacyApplication.school.countryCode
          }
        });
        break;
      case ApplicationActionName.REQUEST_DEFERRAL:
        trackEvent({
          event: 'Single Application - Action Menu - Clicked Request a Deferral'
        });
        break;
      case ApplicationActionName.REQUEST_TUITION_DEPOSIT_REFUND:
        trackEvent({
          event: 'Single Application - Action Menu - Clicked Request a Tuition Refund'
        });
        break;
      case ApplicationActionName.RECOMMENDED_PROGRAM:
        trackEvent({
          event: 'Single Application - Action Menu - Clicked See Recommended Programs'
        });
        break;
      case ApplicationActionName.CHANGE_PROGRAM:
        trackEvent({
          event: 'Single Application - Change Program - Started Change Program Modal'
        });
        break;
    }
  };
  var closeDialog = function closeDialog(open) {
    if (!open) {
      setSelectedAction(null);
    }
  };
  var hideSelfServeDropdwonOnLargeScreen = !actions.filter(function (action) {
    return !(action !== null && action !== void 0 && action.showOutsideDropdown);
  }).length;
  return _jsxs(_Fragment, {
    children: [_jsxs(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      children: [actions.filter(function (action) {
        return action === null || action === void 0 ? void 0 : action.showOutsideDropdown;
      }).map(function (action, idx) {
        return _jsx(Hidden, {
          mdDown: true,
          children: _jsx(Button, {
            emphasis: "outlined",
            intent: "primary",
            onClick: action ? function () {
              return _onClick(action.id);
            } : undefined,
            mr: 2,
            children: action === null || action === void 0 ? void 0 : action.name
          })
        }, idx);
      }), _jsxs(Hidden, {
        lgUp: hideSelfServeDropdwonOnLargeScreen,
        children: [_jsx(Button, {
          ref: ref,
          "aria-label": "More Actions",
          emphasis: "outlined",
          intent: "primary",
          leadIcon: MoreVertOutlineIcon,
          onClick: function onClick() {
            setOpen(!open);
          },
          type: "button",
          width: "hug",
          mr: 2
        }), _jsx(MenuPopover, {
          id: menuId,
          anchorEl: ref.current,
          onClose: function onClose() {
            return setOpen(false);
          },
          open: open,
          keepMounted: true,
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
          },
          children: actions.map(function (action, idx) {
            return _jsx(Hidden, {
              lgUp: action === null || action === void 0 ? void 0 : action.showOutsideDropdown,
              children: _jsx(MenuItem, {
                onClick: function onClick() {
                  setOpen(false);
                  if (action) {
                    _onClick(action.id);
                  }
                },
                children: action === null || action === void 0 ? void 0 : action.name
              })
            }, idx);
          })
        })]
      })]
    }), _jsx(CancelApplicationModal, {
      open: selectedAction === ApplicationActionName.CANCEL,
      onClose: function onClose() {
        setSelectedAction(null);
      },
      onSuccess: function onSuccess() {
        setSelectedAction(null);
      },
      applicationId: props.applicationId,
      cancelApplication: cancelApplication,
      isCancellingApplication: isCancellingApplication
    }), _jsx(ChangeIntakeModal, {
      hideDialogTrigger: true,
      isOpenViaProp: selectedAction === 'change_intake',
      origin: "self serve",
      onOpenChange: closeDialog,
      onSuccess: props.onChangeIntakeSuccess
    }), _jsx(RecommendedProgramsDialog, {
      triggerSettings: {
        hide: true
      },
      isOpen: selectedAction === 'get_recommended_programs',
      onOpenChange: closeDialog,
      origin: "self-serve",
      school: {
        id: legacyApplication.school.id,
        country: legacyApplication.school.countryCode
      },
      program: {
        id: program === null || program === void 0 ? void 0 : program.programId,
        level: program === null || program === void 0 ? void 0 : program.levelText
      },
      academicIntake: program === null || program === void 0 ? void 0 : program.intake.startDate,
      eslIntake: programEsl === null || programEsl === void 0 ? void 0 : programEsl.intake.startDate
    }), _jsx(RequestDeferralDialog, {
      isOpen: selectedAction === 'request_deferral',
      onOpenChange: closeDialog,
      onSuccess: function onSuccess() {
        trackEvent({
          event: 'Single Application - Action Menu - Request a Deferral - Clicked Submit'
        });
      }
    }), _jsx(RequestTuitionDepositRefundDialog, {
      isOpen: selectedAction === 'request_tuition_deposit_refund',
      onOpenChange: closeDialog,
      onSuccess: function onSuccess() {
        trackEvent({
          event: 'Single Application - Action Menu - Request a Tuition Refund - Clicked Submit'
        });
      }
    }), _jsx(ProcessDeferralModal, {
      isOpen: selectedAction === 'finish_deferral' || selectedAction === 'cancel_deferral',
      onOpenChange: closeDialog,
      deferralAction: selectedAction === 'finish_deferral' || selectedAction === 'cancel_deferral' ? selectedAction : null,
      onSuccess: props.onProcessDeferralSuccess,
      onDismissSuccess: props.onDismissProcessDeferralSuccess
    }), _jsx(ChangeProgramModal, {
      isOpen: selectedAction === 'change_program',
      onOpenChange: closeDialog,
      onSuccess: props.onChangeProgramSuccess
    })]
  });
};